import { useContext } from 'react';

import { ConfirmationDialogContext } from '../components/ConfirmationDialogProvider';

const useConfirmationDialogContext = () => useContext(ConfirmationDialogContext);

export default useConfirmationDialogContext;
